import React, { useEffect, useState } from "react";
import logo from "../../assets/logo.svg";
import { Link, useLocation } from "react-router-dom";
import { HiMiniSignal } from "react-icons/hi2";
import { RiMenu3Line } from "react-icons/ri";
import { MdClose } from "react-icons/md";
import clsx from "clsx";

const MobileNav = () => {
  const [state, setState] = useState(false);

  useEffect(() => {
    let grab = document.getElementsByTagName("body");
    if (state) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "scroll";
    }
  }, [state]);

  return (
    // <div className="bg-secondary py-2">
    <nav className="hidden justify-between m-auto items-center max-w-7xl  max-md:px-5 max-sm:flex">
      <Link onClick={() => setState(!state)} to="/">
        <img className="max-w-16 max-sm:max-w-14" src={logo} alt="logo" />
      </Link>

      <ul
        className={clsx(
          " flex gap-8 flex-col border-2 items-center pt-20 text-sm font-medium absolute bg-white top-0 z-50 w-[70%] h-screen z-20 transition-all",
          state ? "-right-0" : "-right-full"
        )}>
        {" "}
        <Child onClick={() => setState(!state)} name={"Home"} route={"/"} />
        <Child
          name={"Courses"}
          route={"/funnels"}
          onClick={() => setState(!state)}
        />
        <Child
          name={"Contact us"}
          route={"/ContactUs"}
          onClick={() => setState(!state)}
        />
      </ul>
      <div
        onClick={() => setState(!state)}
        className=" cursor-pointer text-primary text-2xl z-50 ">
        {state ? <MdClose /> : <RiMenu3Line />}
      </div>
    </nav>
  );
};

export default MobileNav;

let Child = ({ route, name, onClick }) => {
  let { pathname } = useLocation();
  let route_check = pathname.split(" ").pop();

  return (
    <>
      {name === "Courses" ? (
        <li onClick={onClick}>
          <Link
            className={clsx(
              route_check === route && "text-textColor",
              "flex items-center gap-2"
            )}
            to="/funnels">
            {name} <HiMiniSignal className="mt-[2px] text-[#FB2B3A] text-xl " />{" "}
          </Link>
        </li>
      ) : (
        <li
          onClick={onClick}
          className={clsx(route_check === route && "text-textColor")}>
          <Link to={route}>{name}</Link>
        </li>
      )}
    </>
  );
};

//  <nav className="hidden justify-between m-auto items-center max-w-7xl  max-md:px-5 max-sm:flex">
//    <Link to="/">
//      <img className="max-w-16 max-sm:max-w-14" src={logo} alt="logo" />
//    </Link>

//    <ul
//      className={clsx(
//        " flex gap-8 flex-col border-2 items-center pt-20 text-sm font-medium absolute bg-white top-0  w-[70%] h-screen z-20 transition-all",
//        state ? "-right-0" : "-right-full"
//      )}>
//      {" "}
//      <div
//        onClick={() => setState(!state)}
//        className=" cursor-pointer text-primary text-2xl absolute mr-0 right-4 top-4 ">
//        <MdClose />
//      </div>
//      <Child name="Home" route="/" onClick={() => setState(!state)} />
//      <Child name="Course" route="/courses" onClick={() => setState(!state)} />
//      <li>
//        <Link onClick={() => setState(!state)}>Contact Us</Link>
//      </li>
//    </ul>
//    <div
//      onClick={() => setState(!state)}
//      className=" cursor-pointer text-primary text-2xl  ">
//      <RiMenu3Line />
//    </div>
//  </nav>;
